// extracted by mini-css-extract-plugin
export default {"parent_container":"ManageSpecialist_parent_container__JGHWS"};